const messagesInputAuthSms = {
  available: {
    visible: true,
    text: 'para ingresar tu código.',
    textColor: '#646569',
    button: {
      visible: false,
      text: 'Reenviar',
      textColor: '#EC1B2B',
    },
  },
  timeExpired: {
    visible: true,
    text: 'para ingresar tu código.',
    textColor: '#BF0238',
    button: {
      visible: true,
      text: 'Reenviar un nuevo código',
      textColor: '#BF0238',
    },
  },
  incorretCode: {
    visible: true,
    text: 'El código ingresado es incorrecto. Por favor ingrésalo nuevamente.',
    colorText: '#BF0238',
    button: {
      visible: false,
      text: 'Reintentar',
      colorText: '#BF0238',
    },
  },
  retry: {
    visible: true,
    button: {
      visible: true,
      text: 'Reintentar',
      colorText: '#BF0238',
    },
  },
  locked: {
    visible: false,
  },
};

export default messagesInputAuthSms;
